// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__h3kbt","requiredAsterisk":"Info_requiredAsterisk__3dARo"};